import { Button } from '@/components/ui/Button'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/Dialog'

interface WelcomeModalProps {
	isOpen: boolean
	onStartTour: () => void
	onDismiss: () => void
}

export function WelcomeModal({ isOpen, onStartTour, onDismiss }: WelcomeModalProps) {
	return (
		<Dialog open={isOpen} onOpenChange={(open) => !open && onDismiss()}>
			<DialogContent className="welcome-modal">
				<DialogHeader>
					<DialogTitle>Welcome to PlaySmith!</DialogTitle>
				</DialogHeader>
				<p className="welcome-modal__text">
					Let's take a quick tour to help you get started with organizing your playbooks.
				</p>
				<DialogFooter>
					<Button variant="ghost" onClick={onDismiss}>
						I'll explore on my own
					</Button>
					<Button variant="action" onClick={onStartTour}>
						Take a quick tour
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
